import React, { useState, useRef } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ParallaxProvider } from 'react-scroll-parallax';
import { HelmetProvider } from 'react-helmet-async';
import './styles/main.scss';
import Navigation from './components/Navigation';
import VideoHeader from './components/VideoHeader';
import ArtistPage from './pages/ArtistPage';
import AgendaPage from './pages/AgendaPage';
import HomePage from './pages/HomePage';
import FoodPage from './pages/FoodPage';
import TicketPage from './pages/TicketPage';
import Footer from './components/Footer';
import Splashscreen from './components/Splashscreen';
import EventPage from './pages/EventPage';
import PageTransition from './components/PageTransition';
import { NavigationProvider } from './components/NavigationContext';

// Composant de redirection
const RedirectComponent = () => {
  const navigate = useNavigate();
  React.useEffect(() => {
    navigate('/');
  }, [navigate]);
  return null;
};

const App = () => {
  const [showSplashscreen, setShowSplashscreen] = useState(true);
  const helmetContext = {};
  const SPLASHSCREEN_DURATION = 2000;
  const location = useLocation();
  const navigate = useNavigate();
  const videoHeaderRef = useRef(null);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const handleSplashscreenComplete = () => {
    setShowSplashscreen(false);
  };

  const customNavigate = (to) => {
    setIsTransitioning(true);
    requestAnimationFrame(() => {
        navigate(to);
        setTimeout(() => setIsTransitioning(false), 300);
    });
};

  return (
    <HelmetProvider context={helmetContext}>
      <ParallaxProvider>
        <NavigationProvider value={{ customNavigate, isTransitioning }}>
          {showSplashscreen && (
            <Splashscreen
              duration={SPLASHSCREEN_DURATION}
              onComplete={handleSplashscreenComplete}
            />
          )}
          <div
            style={{
              opacity: !showSplashscreen ? 1 : 0,
              transition: 'opacity 0.3s ease-in-out',
              visibility: !showSplashscreen ? 'visible' : 'hidden',
            }}
          >
            <Navigation />
            <VideoHeader applyDatesStroke={false} ref={videoHeaderRef} />
            <PageTransition isTransitioning={isTransitioning} videoHeaderRef={videoHeaderRef}>
              <Routes location={location}>
                <Route path="/" element={<HomePage />} />
                <Route path="/artist" element={<ArtistPage />} />
                <Route path="/programmation" element={<AgendaPage />} />
                <Route path="/programmation/:slug" element={<EventPage />} />
                <Route path="/food" element={<FoodPage />} />
                <Route path="/billetterie" element={<TicketPage />} />
                <Route path="/contact" element={<div>Contact à venir</div>} />
                <Route path="*" element={<RedirectComponent />} />
              </Routes>
              <Footer />
            </PageTransition>
          </div>
        </NavigationProvider>
      </ParallaxProvider>
    </HelmetProvider>
  );
};

export default App;
